module.exports = __webpack_public_path__ + "img/applicant_address.18bf9ee8.svg";